module.exports = __webpack_public_path__ + "static/media/library.20bf9ec2.jpg";